import { ProductForm } from '../web-components/product-form';
import { VariantSelector } from '../web-components/variant-selector';
import { UMGDates } from '../web-components/umg-dates';
import { QuickModal } from '../web-components/quick-modal';
import { carouselInit } from './carousel';
import { BackInStockForm } from '../web-components/back-in-stock-form';